import axios from 'axios'

export default {
    create(payload) {
        return axios.post('/patient-records/requests', payload)
    },

    getPatientRecordRequest(userId, practiceId, patientId) {
        const _fields = [
            'id',
            'patient(id)',
            'npiNumber',
            'toUser(id)',
            'fromUser(id)',
            'toProviderName',
            'toProviderEmail',
            'toProviderPhone',
            'toProviderAddress',
            'toProviderFax',
            'dateFrom',
            'dateTo',
            'purpose',
            'recordTypes',
            'notes',
            'hipaaFormId',
            'status',
            'rejectReason',
            'expirationDate',
            'hipaaSigned',
            'createdDateTime',
            'deletedDateTime',
            'emailRequest',
        ].join(',')
        return axios.get('/patient-records/requests', {
            params: {
                userId,
                patientId,
                practiceId,
                _fields,
            },
        })
    },

    getRecordTypeSources() {
        return axios.get(`/patient-records/sources`)
    },

    createHipaaForm(payload) {
        return axios.post('/patient-records/hipaa-form', payload)
    },

    getHipaaFormList(userId, patientId, { limit, offset } = {}) {
        const _fields = [
            'id',
            'authorizationName',
            'name',
            'fileName',
            'patientId',
            'createdDateTime',
            'fromPracticeId',
            'fromUserId',
            'scope',
            'checksum',
            'size',
            'expiryDate',
            'authorizedProviders',
            'url',
        ].join(',')
        return axios.get(`/patient-records/${userId}/hipaa-form/${patientId}`, { params: { _fields, limit, offset } })
    },

    getUploadRequestInfo(token) {
        return axios.get(`/unauthenticated/patient-records/upload-request/${token}`)
    },

    verifyAccessCode(token, accessCode) {
        return axios.post(`/unauthenticated/patient-records/upload-request/${token}/verify`, { accessCode })
    },

    getUploadRequestHipaaForm(token) {
        return axios.get(`/unauthenticated/patient-records/upload-request/${token}/hipaa-form`, {
            responseType: 'blob',
        })
    },

    uploadRequestedRecords(token, formData) {
        return axios.post(`/unauthenticated/patient-records/upload-request/${token}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    },
}
